export enum EmployeeTypeString {
	EXT = 'Externe',
	INT = 'Interne'
}

export enum EmployeeType {
	'EXT' = 'EXT',
	'INT' = 'INT'
}
